export default "__VITE_ASSET__CpI6LULM__"